const mutations = {
  SAVE_APPLICATION_SUMMARY(state, data) {
    if (data.referralCallbackUrl) {
      localStorage.setItem('referralCallbackUrl', data.referralCallbackUrl);
    }
    if (data.referralMarketplaceMcode) {
      localStorage.setItem('referralMarketplaceMcode', data.referralMarketplaceMcode);
    }
    state.applicationSummary = data;
    state.latestLoanId = data.latestLoanId;
    localStorage.setItem('latestLoanId', data.latestLoanId);
  },
  SET_LATEST_LOAN_ID(state, data) {
    localStorage.setItem('latestLoanId', data);
    state.latestLoanId = data;
  },
  SET_SUPPORT_ID(state, data) {
    localStorage.setItem('supportId', data);
    state.supportId = data;
  },
  SET_WELCOME_REWARDS_DATA(state, data) {
    state.welcomeRewardsData = data;
  },
  SET_BUSINESS_ADDRESS_PRESENT_FLAG(state, data) {
    state.businessAddressPresentFlag = data;
  },
  SET_SKIPPING_GST_FLAG(state, data) {
    state.skippingGSTFlag = data;
  }
};
export default mutations;
